import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { EmailInput } from '@/components/auth';
import { useAuth, useTelegram } from '@/hooks';
import { useAuthStore } from '@/store/authStore';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login, isLoading, error } = useAuth();
  const { isAuthenticated } = useAuthStore();
  const { hideBackButton, hideMainButton } = useTelegram();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/signals', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // Hide buttons on this page
  useEffect(() => {
    hideBackButton();
    hideMainButton();
  }, [hideBackButton, hideMainButton]);

  const handleSubmit = async (email: string) => {
    const success = await login(email);
    if (success) {
      navigate('/otp');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: '24px',
        backgroundColor: 'var(--tg-theme-bg-color)',
      }}
    >
      {/* Header */}
      <div style={{ textAlign: 'center', marginTop: '40px', marginBottom: '48px' }}>
        <div
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '20px',
            backgroundColor: 'var(--tg-theme-button-color)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            fontSize: '36px',
          }}
        >
          📈
        </div>
        <h1
          style={{
            fontSize: '28px',
            fontWeight: 700,
            color: 'var(--tg-theme-text-color)',
            margin: '0 0 8px',
          }}
        >
          CryptoBuzzer
        </h1>
        <p
          style={{
            fontSize: '15px',
            color: 'var(--tg-theme-hint-color)',
            margin: 0,
            lineHeight: 1.4,
          }}
        >
          Get instant alerts when crypto prices change
        </p>
      </div>

      {/* Login Form */}
      <div style={{ flex: 1 }}>
        <EmailInput
          onSubmit={handleSubmit}
          isLoading={isLoading}
          error={error}
          buttonText="Send OTP"
        />
      </div>

      {/* Footer */}
      <div style={{ textAlign: 'center', marginTop: '24px' }}>
        <p
          style={{
            fontSize: '13px',
            color: 'var(--tg-theme-hint-color)',
            margin: 0,
          }}
        >
          By continuing, you agree to our Terms of Service
        </p>
      </div>
    </div>
  );
};
